import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=d84f344c&scoped=true&lang=pug"
import script from "./Recipe.vue?vue&type=script&lang=js"
export * from "./Recipe.vue?vue&type=script&lang=js"
import style0 from "./Recipe.vue?vue&type=style&index=0&id=d84f344c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84f344c",
  null
  
)

export default component.exports